export const CANVA_REDIRECT_URL = "https://canva.peasy.ai/login-post";
export const CANVA_BASE = "https://canva.peasy.ai";

// export const CANVA_REDIRECT_URL =("https://411d-27-54-180-169.in.ngrok.io/login-post");
// "https://92bb-27-54-180-169.in.ngrok.io/login-post";

// export const CANVA_BASE = "https://92bb-27-54-180-169.in.ngrok.io";
// export const CANVA_BASE = "http://localhost:9000";
